import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "./components/topbar/mt-topbar.ts";
import * as d1 from "./components/sidebar/mt-sidebar.ts";
export const name = "app-main";
export const template = "\n\n\n<mt-topbar></mt-topbar>\n<mt-sidebar is-sidebar-open.bind=\"isSidebarOpen\"></mt-sidebar>\n<!--Main Content Area-->\n<div\n  class=\"select-none bg-ob-backdrop block absolute overflow-hidden w-full h-[calc(100vh-3rem)] top-12 bottom-12 transition-[width,left] duration-300 ${isLoggedIn && isSidebarOpen ? '2xl:w-[calc(100vw-20rem)] 2xl:left-[20rem]' : '2xl:w-screen 2xl:left-0 transform-none'}\">\n  <au-viewport></au-viewport>\n</div>\n";
export default template;
export const dependencies = [ d0, d1 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
